module.exports = __webpack_public_path__ + "img/periodo18.df3634ea.svg";